import React, { useState } from "react";

import { Box, Button, CircularProgress } from "@mui/material";
import Grid from "@mui/material/Grid2";
import PreviewModal from "../../components/itin/PreviewModal";
import {
  DocumentUploadIcon,
  PreviewIcon,
} from "../../assets/Icon/dashboredIcon";
import moment from "moment";
import ListLoadingNew from "../../components/common-components/ListLoadingNew";
import NoOrdersFound from "../../components/common-components/NoOrdersFound";
import useDownloader from "react-use-downloader";
import { getUrl } from "../../stores/incorporation";
import { useAppDispatch } from "../../stores/store";
import {
  FormTItle,
  FormTItleValue,
  OrderTitle,
  StyledGridBoxChild,
} from "./TaxFillingDetailOrder";

interface listDataFormType {
  title?: string;
  value?: any;
  border?: boolean;
  icon?: any;
  key?: string;
  attribute?: string;
  hasDocument?: boolean;
  itemLeft?: boolean;
}

interface OrderDetailCardProps {
  orderFormData: listDataFormType[];
  isViewButton?: boolean;
  isClassName?: boolean;
  cardTitle: string;
  margin?: boolean;
  loading?: boolean;
  countryCode?: any;
  hasUsCompany?: any;
  hasItinDocument?: any;
  hasEINDocument?: any;
  hasDocument?: any;
  data?: any;
  itemLeft?: boolean;
}

const TaxOrderDetailCard = (props: OrderDetailCardProps) => {
  const {
    orderFormData,
    hasUsCompany,
    isViewButton,
    isClassName,
    cardTitle,
    margin,
    loading,
    countryCode,
    hasItinDocument,
    hasDocument,
    hasEINDocument,
    data,
    itemLeft,
  } = props;
  const [openPreview, setOpenPreview] = useState(false);
  const [img, setImg] = useState("");
  const [downloadingFile, setDownloadingFile] = useState<string | null>(null);
  const [showAll, setShowAll] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_IMAGE_URL || "";
  const { download } = useDownloader();
  const dispatch = useAppDispatch();

  // console.log(img, "fdggggggggggggggggggggg")

  // const downloadFn = (fileUrl: string, fileName: string = "document.pdf") => {
  //   const downloadFile = async () => {
  //     try {
  //       const response = await fetch(fileUrl);
  //       if (!response.ok) {
  //         alert("Download failed");
  //         return;
  //       }
  //       const blob = await response.blob();
  //       const downloadUrl = window.URL.createObjectURL(blob);
  //       const a = document.createElement("a");
  //       a.href = downloadUrl;
  //       a.download = fileName;
  //       document.body.appendChild(a);
  //       a.click();
  //       a.remove();
  //       window.URL.revokeObjectURL(downloadUrl);
  //     } catch (error) {
  //
  //       alert("Something went wrong while downloading.");
  //     }
  //   };

  //   downloadFile(); // Trigger download
  // };

  const formatToTimeZone = (
    dateInput: string | Date,
    timeZone: string = Intl.DateTimeFormat().resolvedOptions().timeZone,
    locale: string = "en-US",
    options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "short",
      day: "2-digit",
    }
  ): string => {
    if (!dateInput) return "Invalid Date";

    const date = new Date(
      typeof dateInput === "string" && !dateInput.endsWith("Z")
        ? dateInput + "Z"
        : dateInput
    );

    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }

    return new Intl.DateTimeFormat(locale, {
      timeZone,
      ...options,
    }).format(date);
  };

  const handleDownload = async (
    fileUrl: string,
    fileName: string = "document.pdf"
  ) => {
    try {
      setDownloadingFile(fileUrl);
      // download(fileUrl, fileName);
      const response = await fetch(fileUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/octet-stream",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }

      const reader = response.body?.getReader();
      if (!reader) {
        throw new Error("Failed to get stream reader");
      }

      const stream = new ReadableStream({
        async start(controller) {
          while (true) {
            const result = await reader.read();
            if (result.done) break;
            controller.enqueue(result.value);
          }
          controller.close();
          reader.releaseLock();
        },
      });

      const blob = await new Response(stream).blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      window.open(fileUrl, "_blank");
    } finally {
      setDownloadingFile(null);
    }
  };

  const handleClose = () => {
    setOpenPreview(false);
  };

  //   const industryItem = orderFormData.find(
  //     (item) => item.attribute === "industry_type_name"
  //   );
  //   const industryValue = industryItem?.value;

  //   const filteredOrderFormData = orderFormData.filter((item) => {
  //     if (item.attribute === "business_description") {
  //       return industryValue === "Other";
  //     }
  //     return true;
  //   });

  const handleDownloadUrl = async (url: string, attribute: string) => {
    try {
      setDownloadingFile(attribute);
      const response = await dispatch<any>(getUrl({ url: url }));
      const fileUrl = response?.payload?.data;

      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = fileUrl;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      setDownloadingFile(null);
    } finally {
      setDownloadingFile(null);
    }
  };
  console.log(orderFormData, "orderFormData");
  return (
    <>
      {!isClassName && (
        <OrderTitle
          sx={{
            fontWeight: "600 !important",
          }}
          isClassName={true}
        >
          {cardTitle}
        </OrderTitle>
      )}
      <StyledGridBoxChild
        size={{ xs: 12, md: 12 }}
        sx={{ marginTop: margin ? "20px" : "0" }}
      >
        {isClassName && (
          <OrderTitle
            sx={{
              fontWeight: "600 !important",
              paddingTop: "0px",
            }}
          >
            {cardTitle}
          </OrderTitle>
        )}

        {/* Regular fields (excluding Started and Completed) */}
        {orderFormData
          ?.filter(
            (item) => item.title !== "Started" && item.title !== "Completed"
          )
          ?.slice(0, showAll ? undefined : 4)
          ?.map((item, index) => {
            return (
              <Box
                key={index}
                sx={{
                  borderBottom: item.border ? "1px solid #EAF1FACC" : "none",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  paddingY: "20px",
                }}
              >
                <FormTItle sx={{ fontWeight: "500 !important", width: "50%" }}>
                  {item.title}
                </FormTItle>

                {item.hasDocument ? (
                  <FormTItleValue
                    sx={{
                      fontWeight: "500 !important",
                      paddingLeft: "8px",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.title?.toLowerCase() === "passport scan" ? (
                      // Handle passport as single document (string)
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <span
                          style={{ cursor: "pointer", marginRight: "8px" }}
                          onClick={() => {
                            setOpenPreview(true);
                            setImg(`${baseUrl}${item.value}`);
                          }}
                        >
                          <PreviewIcon />
                        </span>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleDownloadUrl(
                              `${item.value}`,
                              item.attribute || item.key || "default"
                            )
                          }
                        >
                          {downloadingFile === item.attribute ? (
                            <CircularProgress
                              sx={{
                                width: "31px !important",
                                height: "30px !important",
                              }}
                            />
                          ) : (
                            <DocumentUploadIcon />
                          )}
                        </span>
                      </Box>
                    ) : Array.isArray(item.value) ? (
                      // Handle multiple documents (arrays) - show each document in its own row
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 1,
                        }}
                      >
                        {item.value.map((doc: any, docIndex: number) => (
                          <Box
                            key={docIndex}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <span
                              style={{ cursor: "pointer", marginRight: "8px" }}
                              onClick={() => {
                                setOpenPreview(true);
                                setImg(
                                  `${baseUrl}${doc.document_file_url || doc}`
                                );
                              }}
                            >
                              <PreviewIcon />
                            </span>
                            <span
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                handleDownloadUrl(
                                  `${doc.document_file_url || doc}`,
                                  `${
                                    item.attribute || item.key || "default"
                                  }_${docIndex}`
                                )
                              }
                            >
                              {downloadingFile ===
                              `${
                                item.attribute || item.key || "default"
                              }_${docIndex}` ? (
                                <CircularProgress
                                  sx={{
                                    width: "31px !important",
                                    height: "30px !important",
                                  }}
                                />
                              ) : (
                                <DocumentUploadIcon />
                              )}
                            </span>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      // Handle single document
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <span
                          style={{ cursor: "pointer", marginRight: "8px" }}
                          onClick={() => {
                            setOpenPreview(true);
                            setImg(`${baseUrl}${item.value}`);
                          }}
                        >
                          <PreviewIcon />
                        </span>
                        <span
                          style={{ cursor: "pointer" }}
                          onClick={() =>
                            handleDownloadUrl(
                              `${item.value}`,
                              item.attribute || item.key || "default"
                            )
                          }
                        >
                          {downloadingFile === item.attribute ? (
                            <CircularProgress
                              sx={{
                                width: "31px !important",
                                height: "30px !important",
                              }}
                            />
                          ) : (
                            <DocumentUploadIcon />
                          )}
                        </span>
                      </Box>
                    )}
                  </FormTItleValue>
                ) : (
                  <FormTItleValue
                    sx={{
                      fontWeight: "500 !important",
                      wordBreak: "break-all",
                      paddingLeft: "20px",
                    }}
                  >
                    {item.value}
                  </FormTItleValue>
                )}
              </Box>
            );
          })}

        {/* Special row for Started and Completed */}
        {/* {orderFormData?.some(item => item.title === "Started" || item.title === "Completed") && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
              paddingY: "20px",
              borderBottom: "1px solid #EAF1FACC",
            }}
          >
            {orderFormData?.map((item, index) => {
              if (item.title === "Started" || item.title === "Completed") {
                return (
                  <Box
                    key={index}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      flex: 1,
                    }}
                  >
                    <FormTItle
                      sx={{
                        fontWeight: "500 !important",
                        marginBottom: "4px",
                      }}
                    >
                      {item.title}
                    </FormTItle>
                    <FormTItleValue
                      sx={{
                        fontWeight: "500 !important",
                        wordBreak: "break-all",
                        paddingLeft: "0",
                      }}
                    >
                      {item.value}
                    </FormTItleValue>
                  </Box>
                );
              }
              return null;
            })}
          </Box>
        )} */}

        {/* Check if we have Started or Completed fields */}

        {/* Special row for Started and Completed */}
        {/* <Box sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "flex-start",
              justifyContent: "space-between",
              paddingY: "20px",
              borderBottom: "1px solid #EAF1FACC"
            }}>
              {orderFormData?.map((item, index) => {
                if (item.title === "Started" || item.title === "Completed") {
                  return (
                    <Box key={index} sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      flex: 1
                    }}>
                      <FormTItle sx={{ fontWeight: "500 !important", marginBottom: "4px" }}>{item.title}</FormTItle>
                      <FormTItleValue sx={{ fontWeight: "500 !important", wordBreak: "break-all", paddingLeft: "0" }}>
                        {item.value}
                      </FormTItleValue>
                    </Box>
                  );
                }
                return null;
              })}
            </Box> */}

        {hasItinDocument && data?.data?.verified_form_files[0] && (
          <Box
            sx={{
              borderBottom: "1px solid #EAF1FACC",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingY: "20px",
            }}
          >
            <FormTItle>ITIN Document</FormTItle>
            <FormTItleValue
              sx={{ fontWeight: "500 !important", paddingLeft: "8px" }}
            >
              <>
                <span
                  style={{ cursor: "pointer", marginRight: "8px" }}
                  onClick={() => {
                    setOpenPreview(true);
                    setImg(`${baseUrl}${data?.data?.verified_form_files[0]}`);
                  }}
                >
                  <PreviewIcon />
                </span>

                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleDownloadUrl(
                      data?.data?.verified_form_files[0],
                      hasItinDocument
                    )
                  }
                >
                  {downloadingFile === data?.data?.verified_form_files[0] ? (
                    <>
                      <CircularProgress
                        sx={{
                          width: "31px !important",
                          height: "30px !important",
                        }}
                      />
                    </>
                  ) : (
                    <DocumentUploadIcon />
                  )}
                </span>
              </>
            </FormTItleValue>
          </Box>
        )}

        {hasEINDocument && data?.data?.ss4_verified_documents[0] && (
          <Box
            sx={{
              borderBottom: "1px solid #EAF1FACC",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              paddingY: "20px",
            }}
          >
            <FormTItle>EIN Document</FormTItle>
            <FormTItleValue
              sx={{ fontWeight: "500 !important", paddingLeft: "8px" }}
            >
              <>
                <span
                  style={{ cursor: "pointer", marginRight: "8px" }}
                  onClick={() => {
                    setOpenPreview(true);
                    setImg(
                      `${baseUrl}${data?.data?.ss4_verified_documents[0]}`
                    );
                  }}
                >
                  <PreviewIcon />
                </span>

                <span
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    handleDownloadUrl(
                      data?.data?.ss4_verified_documents[0],
                      hasEINDocument
                    )
                  }
                >
                  {downloadingFile === data?.data?.ss4_verified_documents[0] ? (
                    <>
                      <CircularProgress
                        sx={{
                          width: "31px !important",
                          height: "30px !important",
                        }}
                      />
                    </>
                  ) : (
                    <DocumentUploadIcon />
                  )}
                </span>
              </>
            </FormTItleValue>
          </Box>
        )}

        {isViewButton &&
          orderFormData?.filter(
            (item) => item.title !== "Started" && item.title !== "Completed"
          ).length > 4 && (
            <Grid size={{ xs: 12, md: 12 }} sx={{ textAlign: "end" }}>
              <Button
                onClick={() => setShowAll(!showAll)}
                variant="text"
                sx={{
                  borderBottom: "1px solid #2977CC",
                  borderRadius: 0,
                  padding: 0,
                  marginTop: 2,
                  cursor: "pointer",
                  backgroundColor: "transparent",
                  "&:hover": {
                    backgroundColor: "transparent",
                  },
                }}
              >
                {showAll ? "View less" : "View more"}
              </Button>
            </Grid>
          )}

        <PreviewModal open={openPreview} handleClose={handleClose} img={img} />
      </StyledGridBoxChild>
    </>
  );
};

export default TaxOrderDetailCard;
